// Stream per-storefront lookup results as they arrive, calling onRow after each
// one resolves rather than waiting for all of them (issue #16).
//
// Extracted from main.js so it can be unit tested in isolation.

import { normalizeLookup, errorRow } from './normalizeApp.js';

/**
 * Fire one lookup per storefront concurrently and invoke `onRow` with the
 * normalized result as soon as each one settles (resolved or rejected).
 *
 * @param {Array<{code: string, name: string}>} storefronts
 * @param {(trackId: string|number, countryCode: string) => Promise<any>} lookupFn
 * @param {string|number} trackId
 * @param {(row: import('./normalizeApp.js').RegionRow, completedCount: number, total: number) => void} onRow
 * @returns {Promise<import('./normalizeApp.js').RegionRow[]>} Rows in arrival order.
 */
export async function streamLookups(storefronts, lookupFn, trackId, onRow) {
  const total = storefronts.length;
  let completed = 0;
  const rows = [];

  await Promise.all(
    storefronts.map(async (sf) => {
      let row;
      try {
        const result = await lookupFn(trackId, sf.code);
        row = normalizeLookup(sf, result);
      } catch (err) {
        row = errorRow(sf, err?.message ?? 'request failed');
      }
      rows.push(row);
      completed += 1;
      onRow(row, completed, total);
    }),
  );

  return rows;
}
